<app-message-error
    error="You got errors in your form!"
    i18n-error="@@youGotErrorsInYourForm"></app-message-error>
